import { useEffect } from 'react';
import { AsyncThunk } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { useAppSelector } from './use-app-selector';
import { useAppDispatch } from './use-app-dispatch';

export const useFetchSelector = <TSelected = unknown>(
  selector: (state: RootState) => TSelected,
  fetchAction: AsyncThunk<TSelected, void, {}>,
) => {
  const entities = useAppSelector(selector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if ((Array.isArray(entities) && !entities.length) || (!Array.isArray(entities) && !entities)) {
      dispatch(fetchAction());
    }
  }, [dispatch, fetchAction]);

  return entities;
};
